// eslint-disable-next-line import/prefer-default-export
export function isAlertVisible(crumb) {
  if (crumb) {
    return crumb.queryFactItem || (crumb.quickSearchItem && crumb.quickSearchItem.whereClauseImportToken);
  }
  return false;
}
